import { useMemo } from "react";
import type { ChartConfig } from "@ptsd/uikit";

import type { RouterOutputs } from "~/utils/api";

type ScalesDynamics = RouterOutputs["scores"]["bySphere"]["scalesDynamics"];

export const useGetChartConfig = (data: ScalesDynamics) => {
  const config = useMemo(
    () =>
      data?.keys?.reduce<ChartConfig>((acc, cur) => {
        acc[cur] = {
          color: data?.colors?.[cur],
          label: data?.labels?.[cur],
        };
        return acc;
      }, {}),
    [data],
  );

  return config;
};
